import { ApiCaseResponseV2 } from '@/shared/api';
import { getPersonFullName } from '@/shared/helpers/names';
import { useAuthStore } from '@/shared/store/auth.store';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

import { useMembersStore } from '../stores/members.store';

export const useCaseTitle = () => {
  const { t } = useTranslation('features/vfo');
  const { account } = useAuthStore();
  const { members } = useMembersStore();

  return (caseData: ApiCaseResponseV2) => {
    if (!caseData.isPrivateCase) {
      return caseData.title;
    }

    const directUser = caseData.members.find((m) => m.profileId !== account?.id);

    if (!directUser) {
      return caseData.title;
    }

    const directUserData = members.find((m) => m.profileId === directUser.profileId);

    if (!directUserData) {
      return caseData.title;
    }

    return t('caseItem.privateCase', { fullname: getPersonFullName(directUserData, 'display') });
  };
};
